import { Component, OnInit, Input, Inject,ChangeDetectorRef} from '@angular/core';
import { QueryBuilderConfig } from 'angular2-query-builder';
import {CodingService} from './service/coding.service';
import { OptionDTO } from '../model/OptionDTO';
import { RuleAppliedDTO  } from '../model/RuleAppliedDTO';
import { RuleAppliedPropertyDTO  } from '../model/RuleAppliedPropertyDTO';
import { FilterLineDTO  } from '../model/FilterLineDTO';
import { NotificationService } from '@progress/kendo-angular-notification';
import Utils from '../../helpers/Util';
import UtilRules from '../helper/UtilRules'
import { QueryBuilderFilterRuleDTO } from '../model/QueryBuilderFilterRuleDTO';
import { QueryBuilderFilterLineRuleDTO } from '../model/QueryBuilderFilterLineRuleDTO';
import { DOCUMENT } from '@angular/common';
import { ShareService } from '../../commonservices/shared.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'coding-edit',
  styleUrls: ['../rule.scss'],
  templateUrl: 'codingform.component.html',
})

export class CodingFormComponent implements OnInit{
  //filter variable here
  @Input() filter;
  dropDownPage:number = 0;
  dropDownpageSize:number = 10;
  query:FilterLineDTO;
  config: QueryBuilderConfig = {
    entities: {
      clientProfile: {name: 'Client Profile'},
      carrierProfile: {name: 'Carrier Profile'},
      clientCarrierProfile: {name: 'Client Carrier Profile'},
      Invoice: {name: 'Invoice'},
      Shipment: {name: 'Shipment'},
      Uoms: {name: 'Uoms'},
      InvoiceCharges: {name: 'Invoice Charges'},
      InvoiceIDs: {name: 'Invoice IDs'},
      ClientFields: {name: 'Client Fields'},
      SIDS: {name: 'Shipment Ids'}
    },
    fields: {
            //clients here
            "Client.Code":{name: 'Ct: Client Name',type: 'category',options: [],entity:"clientProfile"},
            "Client.Region":{name: 'Ct: Client Region',type: 'category',options: [],entity:"clientProfile"},
            "Client.Country":{name: 'Ct: Client Country',type: 'category',options: [],entity:"clientProfile"},
            "Client.CTLocation":{name: 'Ct: Client City',type: 'category',options: [],entity:"clientProfile"},
            "Client.CtClientParent":{name: 'Ct: Client - Parent',type: 'category',options: [],entity:"clientProfile"},
            "Client.FullName":{name: 'Client Name',type: 'category',options: [],entity:"clientProfile"},
            "Client.Division":{name: 'Client Division',type: 'category',options: [],entity:"clientProfile"},
            "Client.SubDiv":{name: 'Client Sub Division',type: 'category',options: [],entity:"clientProfile"},
            "Client.Location":{name: 'Client Location',type: 'category',options: [],entity:"clientProfile"},
            "Client.SubLocation":{name: 'Client Sub Location',type: 'category',options: [],entity:"clientProfile"},
            "ClientId":{name: 'ClientId',type: 'category',options: [],entity:"clientProfile"},
            "Client.Address1":{name: 'Client Address1',type: 'string',options: [],entity:"clientProfile"},
            "Client.Address2":{name: 'Client Address2',type: 'string',options: [],entity:"clientProfile"},
            "Client.City":{name: 'Client City',type: 'category',options: [],entity:"clientProfile"}, 
            "Client.PostCode":{name: 'PostCode',type: 'string',options: [],entity:"clientProfile"},
            "Client.County":{name: 'County',type: 'category',options: [],entity:"clientProfile"},
            "Client.CreatedDate":{name: 'Created Date',type: 'date',options: [],entity:"clientProfile"},

            //carrier here
            "Invoice.CarrierId":{name: 'Carrier Id',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.Name":{name: 'Carrier Short Name',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.Title":{name: 'Carrier Full Name',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.Code":{name: 'Carrier SCAC',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.Region":{name: 'Carrier Region',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.Country":{name: 'Carrier Country',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.Location":{name: 'Carrier Payment Centre: City',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.AccountNumber": {name: 'Carrier Acc No', type: 'string',entity:"carrierProfile"},
            "Carrier.Currency":{name: 'Carrier Currency',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.SubLocation":{name: 'Carrier Operational City',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.Address1":{name: 'Carrier Address1',type: 'string',options: [],entity:"carrierProfile"},
            "Carrier.Address2":{name: 'Carrier Address2',type: 'string',options: [],entity:"carrierProfile"},
            "Carrier.City":{name: 'Carrier City',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.Postcode":{name: 'Postcode',type: 'category',options: [],entity:"carrierProfile"},
            "Carrier.CreatedDate":{name: 'Carrier Created Date',type: 'date',options: [],entity:"carrierProfile"},

            //clientcarrier
            "ClientCarrier.ClientCarrierId":{name: 'ClientCarrierID',type: 'category',options: [],entity:"clientCarrierProfile"},
            "ClientCarrier.GP1":{name: 'Client Carrier Profile	GP1',type: 'category',options: [],entity:"clientCarrierProfile"},
            "ClientCarrier.GP2":{name: 'Client Carrier Profile	GP2',type: 'category',options: [],entity:"clientCarrierProfile"},
            "ClientCarrier.GoLive":{name: 'Client Carrier Profile	GoLiveDate',type: 'date',options: [],entity:"clientCarrierProfile"},
            "ClientCarrier.CreatedDate":{name: 'Client Carrier Profile	Creation Date',type: 'date',options: [],entity:"clientCarrierProfile"},

            //invoice
            "InvoiceNo": {name: 'Invoice No', type: 'string',entity:"Invoice"},
            "FreightBillDate": {name: 'Invoice Date', type: 'date',entity:"Invoice"},
            "DueDate": {name: 'Invoice	Due Date', type: 'date',entity:"Invoice"},
            "Currency": {name: 'Invoice	 Currency', type: 'category',entity:"Invoice"},
            "BilledAmount": {name: 'Invoice	 Amount', type: 'string',entity:"Invoice"},
            "InvoiceType": {name: 'Invoice	Document Type', type: 'category',options: [{name: 'Invoice', value: "100"},{name: 'Credit Note', value: "101"}],entity:"Invoice"},
            "ApprovedAmount": {name: 'Invoice	Approved Amount', type: 'string',entity:"Invoice"},
            "Status": {name: 'Invoice	Rate Status', type: 'category',entity:"Invoice"},
            "Comments": {name: 'Invoice	Auditors Comments', type: 'string',entity:"Invoice"},

            //shipment
            "InvoiceShipment.Id":{name: 'Shipment ID',type: 'string',options: [],entity:"Shipment"},
            "ShipmentClientFields":{name: 'Shipment	Client Fields',type: 'category',options: [],entity:"Shipment"}, //todo:
            "InvoiceShipment.ShipmentMode":{name: 'Shipment Mode',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.ServiceLevel":{name: 'Shipment Service Type',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.FreightTerms":{name: 'Shipment Freight Terms',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.ShipmentDate":{name: 'Shipment Date',type: 'date',options: [],entity:"Shipment"},
            "InvoiceShipment.OriginCountryCode":{name: 'Shipment Origin Country Code',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.Origin":{name: 'Shipment 	Origin State',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.OriginPostcode":{name: 'Shipment 	Origin Postcode',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.OriginCity":{name: 'Shipment 	Origin City',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.Address1":{name: 'Shipment 	Origin Address 2',type: 'string',options: [],entity:"Shipment"},
            "InvoiceShipment.Address2":{name: 'Shipment 	Origin Address 1',type: 'string',options: [],entity:"Shipment"},
            "InvoiceShipment.DestinationPostcode":{name: 'Shipment 	Destination Postcode',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.DestinationPortcode":{name: 'Shipment 	Destination Port Code',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.DestinationAddress1":{name: 'Shipment 	Destinationa Address 2',type: 'string',options: [],entity:"Shipment"},
            "InvoiceShipment.DestinationAddress2":{name: 'Shipment 	Destination Address 1',type: 'string',options: [],entity:"Shipment"},
            "InvoiceShipment.ConsigneeName":{name: 'Shipment 	Consignee Name',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.ShipmentCurrency":{name: 'Shipment 	Shipment Currency',type: 'category',options: [],entity:"Shipment"},
            "InvoiceShipment.BilledAmount":{name: 'Shipment 	Shipment Amount',type: 'string',options: [],entity:"Shipment"},
            "InvoiceShipment.InvoiceUOM.UOM.Id":{name: 'Uom Type',type: 'category',options: [],entity:"Uoms"}, 
            "InvoiceShipment.InvoiceUOM.Amount":{name: 'Invoice Value',type: 'number',options: [],entity:"Uoms"},
            "InvoiceShipment.InvoiceClientField.FieldName":{name: 'Invoice ClientField Field Name',type: 'category',options: [],entity:"ClientFields"},
            "InvoiceShipment.InvoiceAccessorial.Code":{name: 'Code',type: 'category',options: [],entity:"InvoiceCharges"},
            "InvoiceShipment.InvoiceAccessorial.Amount":{name: 'Invoice Accessorial Value',type: 'number',options: [],entity:"InvoiceCharges"},
            "InvoiceShipment.InvoiceClientField.Value":{name: 'Invoice Client Field Value',type: 'string',options: [],entity:"ClientFields"},
            "InvoiceShipment.InvoiceSID.Name":{name: 'SID Type',type: 'category',options: [],entity:"SIDS"},
            "InvoiceShipment.InvoiceSID.Value":{name: 'Invoice Value',type: 'string',options: [],entity:"SIDS"},
            "InvoiceId.Name":{name: 'InvoiceId Field Name',type: 'category',options: [],entity:"InvoiceIDs"},
            "InvoiceId.Value":{name: 'InvoiceId Field Value',type: 'inputBtn',options: [],entity:"InvoiceIDs"},
    }
  }
  fieldsTypeMap = [
    // Client Here
    {field: 'Client.Code',type:"string"},
    {field: 'Client.Region',type:"string"},
    {field: 'Client.Country',type:"string"},
    {field: 'Client.CTLocation',type:"string"}, 
    {field: 'Client.CtClientParent',type:"string"},
    {field: 'Client.FullName',type:"string"},
    {field: 'Client.Division',type:"string"},
    {field: 'Client.SubDiv',type:"string"},
    {field: 'Client.Location',type:"string"},
    {field: 'Client.SubLocation',type:"string"},
    {field: 'ClientId',type:"integer"},
    {field: 'Client.Address1',type:"string"},
    {field: 'Client.Address2',type:"string"},
    {field: 'Client.City',type:"string"},
    {field: 'Client.PostCode',type:"string"},
    {field: 'Client.County',type:"string"},
    {field: 'Client.CreatedDate',type:"date"},
    {field: 'Client.CreatedDate',type:"date"},

    // Carrier Here
    {field: 'Invoice.CarrierId',type:"integer"},
    {field: 'Carrier.Name',type:"string"},
    {field: 'Carrier.Title',type:"string"},
    {field: 'Carrier.Code',type:"string"},
    {field: 'Carrier.Region',type:"string"},
    {field: 'Carrier.Country',type:"string"},
    {field: 'Carrier.Location',type:"string"},
    {field: 'Carrier.AccountNumber',type:"string"},
    {field: 'CarrierCurrency',type:"string"},
    {field: 'Carrier.SubLocation',type:"string"},
    {field: 'Carrier.Address1',type:"string"},
    {field: 'Carrier.Address2',type:"string"},
    {field: 'Carrier.City',type:"string"},
    {field: 'Carrier.Postcode',type:"string"},
    {field: 'Carrier.CreatedDate',type:"date"},

   // ClientCarrier Here
    {field: 'ClientCarrier.ClientCarrierId',type:"integer"},
    {field: 'ClientCarrier.GP1',type:"string"},
    {field: 'ClientCarrier.GP2',type:"string"},
    {field: 'ClientCarrier.GoLive',type:"date"},
    {field: 'ClientCarrier.CreatedDate',type:"date"},

    // Invoice Here
    {field: 'InvoiceNo',type:"string"},
    {field: 'FreightBillDate',type:"date"},
    {field: 'DueDate',type:"date"},
    {field: 'Currency',type:"string"},
    {field: 'BilledAmount',type:"string"},
    {field: 'InvoiceType',type:"string"},
    {field: 'ApprovedAmount',type:"string"},
    {field: 'Status',type:"string"},
    {field: 'InvoiceId.Value',type:"string"},
    {field: 'InvoiceId.Name',type:"string"},
    {field: 'Comments',type:"string"},

    // Shipment Here
    {field: 'InvoiceShipment.Id',type:"integer"},
    {field: 'InvoiceShipment.ShipmentMode',type:"integer"},
    {field: 'InvoiceShipment.ServiceLevel',type:"integer"},
    {field: 'InvoiceShipment.FreightTerms',type:"integer"},
    {field: 'InvoiceShipment.ShipmentDate',type:"date"},
    {field: 'InvoiceShipment.OriginCountryCode',type:"string"},
    {field: 'InvoiceShipment.Origin',type:"string"},
    {field: 'InvoiceShipment.OriginPostcode',type:"integer"},
    {field: 'InvoiceShipment.OriginCity',type:"string"},
    {field: 'InvoiceShipment.Address1',type:"string"},
    {field: 'InvoiceShipment.Address2',type:"string"},
    {field: 'InvoiceShipment.DestinationPostcode',type:"string"},
    {field: 'InvoiceShipment.DestinationPortcode',type:"string"},
    {field: 'InvoiceShipment.DestinationAddress1',type:"string"},
    {field: 'InvoiceShipment.DestinationAddress2',type:"string"},
    {field: 'InvoiceShipment.ShipmentCurrency',type:"integer"},
    {field: 'InvoiceShipment.BilledAmount',type:"string"},
    {field: 'InvoiceShipment.InvoiceClientField',type:"string"},
    {field: 'InvoiceShipment.InvoiceUOM.Amount',type:"double"},
    {field: 'InvoiceShipment.InvoiceUOM.UOM.Id',type:"integer"},
    {field: 'InvoiceShipment.InvoiceAccessorial.Code',type:"string"},
    {field: 'InvoiceShipment.InvoiceAccessorial.Amount',type:"double"},
    {field: 'InvoiceShipment.InvoiceClientField.Value',type:"string"},
    {field: 'InvoiceShipment.InvoiceClientField.FieldName',type:"string"},
    {field: 'InvoiceShipment.InvoiceSID.Name',type:"string"},
    {field: 'InvoiceShipment.InvoiceSID.Value',type:"string"},
  
  ];

  //rules variable here
  ruleLeft:Array<RuleAppliedPropertyDTO> = [];
  ruleRight:Array<RuleAppliedDTO> = [];
  selectedRightRule:any;
  entityDropDown:any;
  fieldDropDown:any;
  excelData: any[][];
  page:number = 0;
  pageClientId:number = 0;
  pageSize:number = 10;
  pageClientCode:number = 0;
  pageClientRegion:number = 0;
  pageClientCountry:number = 0;
  pageClientCTLocation:number = 0;
  pageClientCity:number = 0;
  pageClientParent:number = 0;
  pageClientFullName:number = 0;
  pageClientDivision:number = 0;
  pageClientSubDivision:number = 0;
  pageClientLocation:number = 0;
  pageClientSubLocation:number = 0;
  pageClientCounty:number = 0;
  pageCarrierId:number = 0;
  pageCarrierName:number = 0;
  pageCarrierTitle:number = 0;
  pageCarrierCode:number = 0;
  pageCarrierRegion:number = 0;
  pageCarrierLocation:number = 0;
  pageCarrierSubLocation:number = 0;
  pageCarrierCurrency:number = 0;
  pageCarrierCountry:number = 0;
  pageCarrierCity:number = 0;
  pageCarrierPostcode:number = 0;
  pageClientCarrierId:number = 0;
  pageClientCarrierGP1:number = 0;
  pageClientCarrierGP2:number = 0;
  pageCurrency:number = 0;
  pageStatus:number = 0;
  pageShipmentMode:number = 0;
  pageServiceLevel:number = 0;
  pageOriginPostcode:number = 0;
  pageDestinationPostcode:number = 0;
  pageFreightTerms:number = 0;
  pageOriginCountryCode:number = 0;
  pageDestinationPortcode:number = 0;
  pageShipmentCurrency:number = 0;
  pageOrigin:number = 0;
  pageOriginCity:number = 0;
  pageAccessorial:number = 0;
  isInitProperyDropDown:boolean = false;
  isSaveAsFilter:boolean = false;

  constructor(private _codingService: CodingService
            ,private _notificationService: NotificationService,  
            @Inject(DOCUMENT) private _document: Document,
            private _sharedService: ShareService,
            private changeDetectorRef: ChangeDetectorRef) {
          
  }

  ngOnInit()  {
    this.initFilterDropDown();
    this.initFilterLine();
    this.initRules();
    this.isInitProperyDropDown = false;
    this.selectedRightRuleChanges();
  }

  public onExportExcel($e){
    var rule = $e;
    const fileName = 'DropDownValue.xlsx';
    var data = [];
    rule.value.forEach(element => {
      var x = {element};
      data.push( {element}); 
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data,{skipHeader: true});
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws);

		XLSX.writeFile(wb, fileName);
  }

  public onFileChange($e){
    /* wire up file reader */
    var evt = $e.event;
    var rule = $e.rule;
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.excelData = <any>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      var data = [];
      this.excelData.forEach(x=>{
        data.push(x.toString())
      })
      rule.value = data;
    };
    reader.readAsBinaryString(target.files[0]);
    this.changeDetectorRef.detectChanges();
  }

  public initFilterDropDown(){
    this._codingService.GetClientId(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => { 
      this.config.fields["ClientId"].options = data;
    });
    this._codingService.GetClientCode().subscribe((data:Array<OptionDTO>) =>  { 
      this.config.fields["Client.Code"].options = data;
    });

    this._codingService.GetClientRegion(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => { 
      this.config.fields["Client.Region"].options = data;
    });

    this._codingService.GetClientCountryCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) =>{ 
      this.config.fields["Client.Country"].options = data;
    });

    this._codingService.GetCTClientCity(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Client.CTLocation"].options = data;
    });

    this._codingService.GetClientCity(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Client.City"].options = data;
    });

    this._codingService.GetCTClientParentName(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Client.CtClientParent"].options = data;
    });

    this._codingService.GetCTClientFullName(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Client.FullName"].options = data;
    });

    this._codingService.GetClientDivision(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Client.Division"].options = data;
    });

    this._codingService.GetClientSubDivision(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Client.SubDiv"].options = data;
    });

    this._codingService.GetClientLocation(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Client.Location"].options = data;
    });

    this._codingService.GetClientSubLocation(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Client.SubLocation"].options = data;
    });

    this._codingService.GetClientCountyCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Client.County"].options = data;
    });

    this._codingService.GetCarrierID(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Invoice.CarrierId"].options = data;
    });

    this._codingService.GetCarrierShortName(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Carrier.Name"].options = data;
    });

    this._codingService.GetCarrierFullName(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Carrier.Title"].options = data;
    });

    this._codingService.GetCarrierSCAC(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Carrier.Code"].options = data;
    });

    this._codingService.GetCarrierRegion(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Carrier.Region"].options = data;
    });

    this._codingService.GetCarrierLocation(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields['Carrier.Location'].options = data;
    });

    this._codingService.GetCarrierSubLocation(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Carrier.SubLocation"].options = data;
    });

    this._codingService.GetCarrierCurrency(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.CarrierCurrency.options = data;
    });

    this._codingService.GetCarrierCountryCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields['Carrier.Country'].options = data;
    });

    this._codingService.GetCarrierCity(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Carrier.City"].options = data;
    });

    this._codingService.GetCarrierPostCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Carrier.Postcode"].options = data;
    });

    this._codingService.GetClientCarrierId(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["ClientCarrier.ClientCarrierId"].options = data;
    });

    this._codingService.GetClientCarrierGP1(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["ClientCarrier.GP1"].options = data;
    });

    this._codingService.GetClientCarrierGP2(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.ClientCarrierProfileGP2.options = data;
    });

    this._codingService.GetCurrency(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.Currency.options = data;
      this.config.fields["InvoiceShipment.ShipmentCurrency"].options = data;
    });

    this._codingService.GetInvoiceStatus(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["Status"].options = data;
    });

    this._codingService.GetShipMode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.ShipmentMode"].options = data;
    });

    this._codingService.GetSrvceType(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.ServiceLevel"].options = data;
    });

    this._codingService.GetFreightTerm(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.FreightTerms"].options = data;
    });
    
    this._codingService.GetCountryCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.OriginCountryCode"].options = data;
    });

    this._codingService.GetGeoPortCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.DestinationPortcode"].options = data;
    });

    this._codingService.GetGeoPostCode(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.OriginPostcode"].options = data;
      this.config.fields["InvoiceShipment.DestinationPostcode"].options = data;
    });

    this._codingService.GetShipmentOriginState(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.Origin"].options = data;
    });

    this._codingService.GetShipmentCity(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.OriginCity"].options = data;
    });

    this._codingService.GetAccessorialName(this.dropDownPage,this.dropDownpageSize).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields.Accessorial.options = data;
    });

    this._codingService.GetUOM().subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.InvoiceUOM.UOM.Id"].options = data;
    });

    this._codingService.GetInvoiceIdsListDropDown(this.filter.ClientCode,this.page,this.pageSize,this.filter).subscribe((data:Array<any>) =>
    {
      this.config.fields["InvoiceId.Name"].options = data;
      this.changeDetectorRef.detectChanges();
    });

    this._codingService.GetAllAccessorial().subscribe((data:Array<any>) =>
    {
      this.config.fields["InvoiceShipment.InvoiceAccessorial.Code"].options = data;
      this.changeDetectorRef.detectChanges();
    })

    this._codingService.GetClientField(this.filter.ClientCode).subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.InvoiceClientField.FieldName"].options = data;
    });

    this._codingService.GetSID().subscribe((data:Array<OptionDTO>) => 
    { 
      this.config.fields["InvoiceShipment.InvoiceSID.Name"].options = data;
    });
  }

  public initFilterLine(){
    this.query = { id:0, field: "", value:[], entity:"", condition: 'and', type: 'Coding', rules: [], collapsed:"",isChild:"" } as FilterLineDTO;
    if(this.filter.Id != 0){
      this._codingService.GetFilterLineWithChild(this.filter.Id).subscribe((data:any) => 
      {
      
        UtilRules.FormatRuleToString(data);
        this.query  = data;
        console.log(this.query);
      });
    }
  }

  public initRules() {
    if(this.filter.Id == 0){
      this.ruleRight = [];
      this._codingService.GetUnAppliedRules().subscribe((data:Array<RuleAppliedPropertyDTO>) =>
      {
        this.ruleLeft = data;
      });
    }else{  
      this._codingService.GetUnAppliedRules().subscribe((data:Array<RuleAppliedPropertyDTO>) =>
      {
        this.ruleLeft = data;
      });
  
      this._codingService.GetAppliedRulesByFilterId(this.filter.Id).subscribe((data:Array<RuleAppliedDTO>) =>
      {
        this.ruleRight = data;
      });
    }
  }

  public sucessMessage(){
    this._notificationService.show({
      content: 'Successfully saved!',
      animation: { type: 'fade', 
      duration: 500 },
      type: { style: 'info', icon: true }
     });
  }

  public sucessUpdateMessage(){
    this._notificationService.show({
      content: 'Successfully updated!',
      animation: { type: 'fade', 
      duration: 500 },
      type: { style: 'info', icon: true }
    });
  }

  onfetchMore(rule) {
    if(rule.field == 'ClientId'){
      this.pageClientId = this.pageClientId + 1;
      this._codingService.GetClientId(this.pageClientId,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientId"].options.push(...data);
      });
    }else if(rule.field == 'Client.Code'){
      this.pageClientCode = this.pageClientCode + 1;
      this._codingService.GetClientCode().subscribe((data:Array<OptionDTO>) => 
      { 
        if(data.length > 0){
          this.config.fields['Client.Code'].options = data;
        }
      });
    }else if(rule.field == 'Client.Region'){
      this.pageClientRegion = this.pageClientRegion + 1;
      this._codingService.GetClientRegion(this.pageClientRegion,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Region"].options.push(...data);
      });
    }else if(rule.field == 'Client.Country'){
      this.pageClientCountry = this.pageClientCountry + 1;
      this._codingService.GetCTClientCountry(this.pageClientCountry,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Country"].options.push(...data);
      });
    }else if(rule.field == 'Client.CTLocation'){
      this.pageClientCTLocation = this.pageClientCTLocation + 1;
      this._codingService.GetCTClientCity(this.pageClientCTLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.CTLocation"].options.push(...data);
      });

    }else if(rule.field == 'Client.City'){
      this.pageClientCity = this.pageClientCity + 1;
      this._codingService.GetClientCity(this.pageClientCity,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.City"].options.push(...data);
      });
    }
    else if(rule.field == 'Client.CtClientParent'){
      this.pageClientParent = this.pageClientParent + 1;
      this._codingService.GetCTClientParentName(this.pageClientParent,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.CtClientParent"].options.push(...data);
      });
    }else if(rule.field == 'Client.FullName'){
      this.pageClientFullName = this.pageClientFullName + 1;
      this._codingService.GetCTClientFullName(this.pageClientFullName,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.FullName"].options.push(...data);
      });
    }else if(rule.field == 'Client.Division'){
      this.pageClientDivision = this.pageClientDivision + 1;
      this._codingService.GetClientDivision(this.pageClientDivision,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Division"].options.push(...data);
      });
    } else if(rule.field == 'Client.SubDiv'){
      this.pageClientSubDivision = this.pageClientSubDivision + 1;
      this._codingService.GetClientSubDivision(this.pageClientSubDivision,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.SubDiv"].options.push(...data);
      });
    } else if(rule.field == 'Client.Location'){
      this.pageClientLocation = this.pageClientLocation + 1;
      this._codingService.GetClientLocation(this.pageClientLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Location"].options.push(...data);
      });
    } else if(rule.field == 'Client.SubLocation'){
      this.pageClientSubLocation = this.pageClientSubLocation + 1;
      this._codingService.GetClientSubLocation(this.pageClientSubLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.SubLocation"].options.push(...data);
      });
    } else if(rule.field == 'Client.Country'){
      this.pageClientCountry = this.pageClientCountry + 1;
      this._codingService.GetClientCountryCode(this.pageClientCountry,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Country"].options.push(...data);
      });
    } else if(rule.field == 'County'){
      this.pageClientCounty = this.pageClientCounty + 1;
      this._codingService.GetClientCountyCode(this.pageClientCounty,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.County"].options.push(...data);
      });
    } else if(rule.field == 'Invoice.CarrierId'){
      this.pageCarrierId = this.pageCarrierId + 1;
      this._codingService.GetCarrierID(this.pageCarrierId,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.CarrierId"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Name'){
      this.pageCarrierName = this.pageCarrierName + 1;
      this._codingService.GetCarrierShortName(this.pageCarrierName,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Name"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Title'){
      this.pageCarrierTitle = this.pageCarrierTitle + 1;
      this._codingService.GetCarrierFullName(this.pageCarrierTitle,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Title"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Code'){
      this.pageCarrierCode = this.pageCarrierCode + 1;
      this._codingService.GetCarrierSCAC(this.pageCarrierCode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Code"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Region'){
      this.pageCarrierRegion = this.pageCarrierRegion + 1;
      this._codingService.GetCarrierRegion(this.pageCarrierRegion,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Region"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Location'){
      this.pageCarrierLocation = this.pageCarrierLocation + 1;
      this._codingService.GetCarrierLocation(this.pageCarrierLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields['Carrier.Location'].options.push(...data);
      });
    } else if(rule.field == 'Carrier.SubLocation'){
      this.pageCarrierSubLocation = this.pageCarrierSubLocation + 1;
      this._codingService.GetCarrierSubLocation(this.pageCarrierSubLocation,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.SubLocation"].options.push(...data);
      });
    } else if(rule.field == 'CarrierCurrency'){
      this.pageCarrierCurrency = this.pageCarrierCurrency + 1;
      this._codingService.GetCarrierCurrency(this.pageCarrierCurrency,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierCurrency.options.push(...data);
      });
    } else if(rule.field == 'Carrier.Country'){
      this.pageCarrierCountry = this.pageCarrierCountry + 1;
      this._codingService.GetCarrierCountryCode(this.pageCarrierCountry,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields['Carrier.Country'].options.push(...data);
      });
    } else if(rule.field == 'Carrier.City'){
      this.pageCarrierCity = this.pageCarrierCity + 1;
      this._codingService.GetCarrierCity(this.pageCarrierCity,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.City"].options.push(...data);
      });
    } else if(rule.field == 'Carrier.Postcode'){
      this.pageCarrierPostcode = this.pageCarrierPostcode + 1;
      this._codingService.GetCarrierPostCode(this.pageCarrierPostcode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Postcode"].options.push(...data);
      });
    }
    if(rule.field == 'ClientCarrier.ClientCarrierId'){
      this.pageClientCarrierId = this.pageClientCarrierId + 1;
      this._codingService.GetClientCarrierId(this.pageClientCarrierId,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientCarrier.ClientCarrierId"].options.push(...data);
      });
    } else if(rule.field == 'ClientCarrier.GP1'){
      this.pageClientCarrierGP1 = this.pageClientCarrierGP1 + 1;
      this._codingService.GetClientCarrierGP1(this.pageClientCarrierGP1,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientCarrier.GP1"].options.push(...data);
      });
    } else if(rule.field == 'ClientCarrier.GP2'){
      this.pageClientCarrierGP2 = this.pageClientCarrierGP2 + 1;
      this._codingService.GetClientCarrierGP2(this.pageClientCarrierGP2,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientCarrier.GP2"].options.push(...data);
      });
    }
    if(rule.field == 'Currency'){
      this.pageCurrency = this.pageCurrency + 1;
      this._codingService.GetCurrency(this.pageCurrency,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Currency.options.push(...data);
      });
    } else if(rule.field == 'Status'){
      this.pageStatus = this.pageStatus + 1;
      this._codingService.GetInvoiceStatus(this.pageStatus,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Status"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.ShipmentMode'){
      this.pageShipmentMode = this.pageShipmentMode + 1;
      this._codingService.GetShipMode(this.pageShipmentMode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.ShipmentMode"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.ServiceLevel'){
      this.pageServiceLevel = this.pageServiceLevel + 1;
      this._codingService.GetSrvceType(this.pageServiceLevel,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.ServiceLevel"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.OriginPostcode'){
      this.pageOriginPostcode = this.pageOriginPostcode + 1;
      this._codingService.GetGeoPostCode(this.pageOriginPostcode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.OriginPostcode"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.DestinationPostcode'){
      this.pageDestinationPostcode = this.pageDestinationPostcode + 1;
      this._codingService.GetGeoPostCode(this.pageDestinationPostcode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.DestinationPostcode"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.FreightTerms'){
      this.pageFreightTerms = this.pageFreightTerms + 1;
      this._codingService.GetFreightTerm(this.pageFreightTerms,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.FreightTerms"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.OriginCountryCode' ){
      this.pageOriginCountryCode = this.pageOriginCountryCode + 1;
      this._codingService.GetCountryCode(this.pageOriginCountryCode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.OriginCountryCode"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.DestinationPortcode'){
      this.pageDestinationPortcode = this.pageDestinationPortcode + 1;
      this._codingService.GetGeoPortCode(this.pageDestinationPortcode,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.DestinationPortcode"].options.push(...data);
      });
    }else if(rule.field == 'InvoiceShipment.ShipmentCurrency'){
        this.pageShipmentCurrency = this.pageShipmentCurrency + 1;
        this._codingService.GetCurrency(this.pageShipmentCurrency,this.pageSize).subscribe((data:Array<OptionDTO>) => 
        { 
          this.config.fields["InvoiceShipment.ShipmentCurrency"].options.push(...data);
        });
    } else if(rule.field == 'InvoiceShipment.Origin' ){
      this.pageOrigin = this.pageOrigin + 1;
      this._codingService.GetShipmentOriginState(this.pageOrigin,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.Origin"].options.push(...data);
      });
    } else if(rule.field == 'InvoiceShipment.OriginCity'){
      this.pageOriginCity = this.pageOriginCity + 1;
      this._codingService.GetShipmentCity(this.pageOriginCity,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.OriginCity"].options.push(...data);
      });
    } else if(rule.field == 'Accessorial'){
      this.pageAccessorial = this.pageAccessorial + 1;
      this._codingService.GetAccessorialName(this.pageAccessorial,this.pageSize).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Accessorial.options.push(...data);
      });
    }
  }

  onSearch($event){
    if($event.field == 'ClientId'){
      this._codingService.GetClientIdByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientId"].options = data;
      });
    }else if($event.field == 'Client.Code'){
      this._codingService.GetClientCodeByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Code"].options = data;
      });
    }else if($event.field == 'Client.Region'){
      this._codingService.GetClientRegionByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Region"].options = data;
      });
    }else if($event.field == 'Client.Country'){
      this._codingService.GetCTClientCountryByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Country"].options = data;
      });
    }else if($event.field == 'Client.CTLocation'){
      this._codingService.GetCTClientCityByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.CTLocation"].options = data;
      });
    }else if($event.field == 'Client.CtClientParent'){
      this._codingService.GetCTClientParentNameByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.CtClientParent"].options = data;
      });
    }else if($event.field == 'Client.FullName'){
      this._codingService.GetCTClientFullNameByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.FullName"].options = data;
      });
    }else if($event.field == 'Client.Division'){
      this._codingService.GetClientDivisionFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Division"].options = data;
      });
    } else if($event.field == 'ClientSubDiv'){
      this._codingService.GetClientSubDivisionFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.SubDiv"].options = data;
      });
    } else if($event.field == 'Client.Location'){
      this._codingService.GetClientLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Location"].options = data;
      });
    } else if($event.field == 'Client.SubLocation'){
      this._codingService.GetClientSubLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.SubLocation"].options = data;
      });
    } else if($event.field == 'Client.Country'){
      this._codingService.GetClientCountryCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.Country"].options = data;
      });
    } else if($event.field == 'County'){
      this._codingService.GetClientCountyCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Client.County"].options = data;
      });
    } else if($event.field == 'Invoice.CarrierId'){
      this._codingService.GetCarrierIDFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Invoice.CarrierId"].options = data;
      });
    } else if($event.field == 'Carrier.Name'){
      this._codingService.GetCarrierShortNameFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Name"].options = data;
      });
    } else if($event.field == 'Carrier.Title'){
      this._codingService.GetCarrierFullNameFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Title"].options = data;
      });
    } else if($event.field == 'Carrier.Code'){ 
      this._codingService.GetCarrierSCACFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields['Carrier.Code'].options = data;
      });
    } else if($event.field == 'Carrier.Region'){ 
      this._codingService.GetCarrierRegionFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Region"].options = data;
      });
    } else if($event.field == 'Carrier.Location'){
      this._codingService.GetCarrierLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields['Carrier.Location'].options = data;
      });
    } else if($event.field == 'Carrier.SubLocation'){
      this._codingService.GetCarrierSubLocationFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.SubLocation"].options = data;
      });
    } else if($event.field == 'CarrierCurrency'){
      this._codingService.GetCarrierCurrencyFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.CarrierCurrency.options = data;
      });
    } else if($event.field == 'Carrier.Country'){
      this._codingService.GetCarrierCountryCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields['Carrier.Country'].options = data;
      });
    } else if($event.field == 'Carrier.City'){
      this._codingService.GetCarrierCityFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.City"].options = data;
      });
    } else if($event.field == 'Carrier.Postcode'){
      this._codingService.GetCarrierPostCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Carrier.Postcode"].options = data;
      });
    }
    if($event.field == 'ClientCarrier.ClientCarrierId'){
      this._codingService.GetClientCarrierIdFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientCarrier.ClientCarrierId"].options = data;
      });
    } else if($event.field == 'ClientCarrier.GP1'){
      this._codingService.GetClientCarrierGP1Filter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientCarrier.GP1"].options = data;
      });
    } else if($event.field == 'ClientCarrier.GP2'){
      this._codingService.GetClientCarrierGP2Filter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["ClientCarrier.GP2"].options = data;
      });
    }
    if($event.field == 'Currency'){
      this._codingService.GetCurrencyByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Currency.options = data;
      });
    } else if($event.field == 'Status'){
      this._codingService.GetInvoiceStatusByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["Status"].options = data;
      });
    } 
    if($event.field == 'InvoiceShipment.ShipmentMode'){
      this._codingService.GetShipModeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.ShipmentMode"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.ServiceLevel'){
      this._codingService.GetSrvceTypeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.ServiceLevel"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.OriginPostcode'){
      this._codingService.GetGeoPostCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.OriginPostcode"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.DestinationPostcode'){
      this._codingService.GetGeoPostCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.DestinationPostcode"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.Origin'){
      this._codingService.GetShipmentOriginStateFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.Origin"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.OriginCity'){
      this._codingService.GetShipmentCityFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.OriginCity"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.FreightTerms'){
      this._codingService.GetFreightTermFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.FreightTerms"].options = data;
      });
    }else if($event.field == 'InvoiceShipment.ShipmentCurrency'){
        this._codingService.GetCurrencyByFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
        { 
          this.config.fields["InvoiceShipment.ShipmentCurrency"].options = data;
        });
    } else if($event.field == 'InvoiceShipment.OriginCountryCode' ){
      this._codingService.GetCountryCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.OriginCountryCode"].options = data;
      });
    } else if($event.field == 'InvoiceShipment.DestinationPortcode'){
      this._codingService.GetGeoPortCodeFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields["InvoiceShipment.DestinationPortcode"].options = data;
      });
    } else if($event.field == 'Accessorial'){
      this._codingService.GetAccessorialNameFilter(0,this.pageSize,$event.term).subscribe((data:Array<OptionDTO>) => 
      { 
        this.config.fields.Accessorial.options = data;
      });
    }
  }

  resetPage()
  {
    this._document.defaultView.location.reload();
  }

  onfetchProperties(){}

  public  selectedRightRuleChanges(){
    this._sharedService.changeEmitted$.subscribe(async(data) => {
      this.selectedRightRule = data;
      if(this.isInitProperyDropDown == false){
        this.selectedRightRule = data;
        this.entityDropDown = Utils.DeepCopy(this.selectedRightRule.RuleProperty[0].Store);
        this.fieldDropDown = Utils.DeepCopy(this.selectedRightRule.RuleProperty[1].Store);
        this.isInitProperyDropDown = true;
      }
      UtilRules.FormatIndividualRuleAppliedPropertiesToString(this.selectedRightRule);
      // //put dropdown to field store of invoiceids and other dynamic dropdown value
      for(var key  of Object.keys(this.selectedRightRule.RuleProperty)){
        if(this.selectedRightRule.RuleProperty[Number(key)].Value == "InvoiceIDs"
          ){
            this.selectedRightRule.RuleProperty[Number(key)+1].Type = "multiselect";
            this.selectedRightRule.RuleProperty[Number(key)+1].Store  = Utils.DeepCopy( this.config.fields["InvoiceId.Name"].options );
            UtilRules.FormatObjectRuleAppliedPropertiesToArray(this.selectedRightRule.RuleProperty[Number(key)+1])
        }else if( this.selectedRightRule.RuleProperty[Number(key)].Value == "ClientFields" 
          && ( this.selectedRightRule.RuleProperty[Number(key)].Type == "combobox" ||  this.selectedRightRule.RuleProperty[Number(key)].Type == "multiselect")){
            this.selectedRightRule.RuleProperty[Number(key)+1].Type = "multiselect";
            this.selectedRightRule.RuleProperty[Number(key)+1].Store  = Utils.DeepCopy(this.config.fields["InvoiceShipment.InvoiceClientField.FieldName"].options)
            UtilRules.FormatObjectRuleAppliedPropertiesToArray(this.selectedRightRule.RuleProperty[Number(key)+1]);
        }else if( this.selectedRightRule.RuleProperty[Number(key)].Value == "Uoms" 
          && ( this.selectedRightRule.RuleProperty[Number(key)].Type == "combobox" ||  this.selectedRightRule.RuleProperty[Number(key)].Type == "multiselect")){
          this.selectedRightRule.RuleProperty[Number(key)+1].Type = "multiselect";
          this.selectedRightRule.RuleProperty[Number(key)+1].Store  =  Utils.DeepCopy(this.config.fields["InvoiceShipment.InvoiceUOM.UOM.Id"].options)
          UtilRules.FormatObjectRuleAppliedPropertiesToArray(this.selectedRightRule.RuleProperty[Number(key)+1]) 
        }else if( this.selectedRightRule.RuleProperty[Number(key)].Value == "InvoiceCharges" 
          && ( this.selectedRightRule.RuleProperty[Number(key)].Type == "combobox" ||  this.selectedRightRule.RuleProperty[Number(key)].Type == "multiselect")){
          this.selectedRightRule.RuleProperty[Number(key)+1].Type = "multiselect";
          this.selectedRightRule.RuleProperty[Number(key)+1].Store  =   Utils.DeepCopy(this.config.fields["InvoiceShipment.InvoiceAccessorial.Code"].options)
          UtilRules.FormatObjectRuleAppliedPropertiesToArray(this.selectedRightRule.RuleProperty[Number(key)+1]);
        }else if( this.selectedRightRule.RuleProperty[Number(key)].Value == "ShipmentIds" 
          && ( this.selectedRightRule.RuleProperty[Number(key)].Type == "combobox" ||  this.selectedRightRule.RuleProperty[Number(key)].Type == "multiselect")){
          this.selectedRightRule.RuleProperty[Number(key)+1].Type = "multiselect";
          this.selectedRightRule.RuleProperty[Number(key)+1].Store  =   Utils.DeepCopy(this.config.fields["InvoiceShipment.InvoiceSID.Name"].options)
          UtilRules.FormatObjectRuleAppliedPropertiesToArray(this.selectedRightRule.RuleProperty[Number(key)+1]);
        }
      }
    })
  }

  public onChangeDropDownProp(valueObj){
    this._sharedService.changeEmitted$.subscribe(async(data) => {
      this.selectedRightRule = data;
      if(this.isInitProperyDropDown == false){
        this.entityDropDown = Utils.DeepCopy(this.selectedRightRule.RuleProperty[0].Store);
        this.fieldDropDown = Utils.DeepCopy(this.selectedRightRule.RuleProperty[1].Store);
        this.isInitProperyDropDown = true;
      }

      //filter if the dropdown being used is the entity or group ex: Invoice, Shipment dropdown
      let entityDropdownFilter = this.entityDropDown.filter(element => {
        return element.value == valueObj.value;
      });

      if(entityDropdownFilter.length > 0){  //if not the entity then we don't do anything.
      //here we change the value of field dropdown accoding to entity or group selected
      //ex: Box1: Invoice then Box2 will have data Duedate,Rejection Date and all data that has group with Invoice
        var scope = this;
        let propRules = this.selectedRightRule.RuleProperty.filter(element => {
          return element.divId == valueObj.divId;
        });

        if(propRules.length > 0){
          let tempselectedRightRuleStore = Utils.DeepCopy(scope.fieldDropDown);
          propRules[1].Store = tempselectedRightRuleStore.filter(element =>{//filter according to entity selected
                                  return element.Group == valueObj.value;
                                });

          if(propRules[1].Value == null){//set the first array of data as default selected
            //  propRules[1].Value = propRules[1].Store[0].value;
          }
        }
        
        if(valueObj.value == "InvoiceIDs" ){
          propRules[1].Type = "multiselect";
          propRules[1].Store  = Utils.DeepCopy( this.config.fields["InvoiceId.Name"].options );
        }else if(valueObj.value == "ClientFields"){
          propRules[1].Type = "multiselect";
          propRules[1].Store  = Utils.DeepCopy(this.config.fields["InvoiceShipment.InvoiceClientField.FieldName"].options)
        }else if(valueObj.value == "Uoms"){
          propRules[1].Type = "multiselect";
          propRules[1].Store  =  Utils.DeepCopy(this.config.fields["InvoiceShipment.InvoiceUOM.UOM.Id"].options)
        }else if(valueObj.value == "InvoiceCharges"){
          propRules[1].Type = "multiselect";
          propRules[1].Store  =  Utils.DeepCopy(this.config.fields["InvoiceShipment.InvoiceAccessorial.Code"].options)
        }else if(valueObj.value == "ShipmentIds" ){
          propRules[1].Type = "multiselect";
          propRules[1].Store  =  Utils.DeepCopy(this.config.fields["InvoiceShipment.InvoiceSID.Name"].options)
        }
      }
    })
  }

  public saveFilter(query){
    var tempData = Utils.DeepCopy(query);
    UtilRules.FormatRuleToArray(tempData,this.fieldsTypeMap);
    var filterData = <QueryBuilderFilterLineRuleDTO> tempData;
    let queryBuilderFilterRuleDTO:QueryBuilderFilterRuleDTO = {"Filter": this.filter , "QueryBuilderFilterLineRule": filterData, "RuleAppliedList": []}
    this._codingService.SaveFilter(queryBuilderFilterRuleDTO).subscribe((filterId:number) => 
    {
      this.filter.Id = filterId;
      this.filter.TabTitle = filterId;
      this._codingService.GetFilterLineWithChild(filterId).subscribe((data:any) => 
      {
        UtilRules.FormatRuleToString(data);
        this.query  = data;
        this.isSaveAsFilter = false;
        this.sucessMessage();
      });
    })
  }

  public saveAsFilter(){
    this.filter.Id = 0;
    this.filter.TabTitle = this.filter.ClientCode;
    this.isSaveAsFilter = true;

  }

  private removeRuleAppledCharacterPlus(ruleApplied:Array<RuleAppliedDTO>){

    ruleApplied.forEach(element => {
        element.Name =  element.Name.replace("+", "");
    });
  }

  public onSaveAppliedRule(ruleApplied:Array<RuleAppliedDTO>){

    if(this.isSaveAsFilter){
      this.removeRuleAppledCharacterPlus(ruleApplied);
    }
    var tempData = Utils.DeepCopy(this.query);
    UtilRules.FormatRuleToArray(tempData,this.fieldsTypeMap);
    var filterData = <QueryBuilderFilterLineRuleDTO> tempData;
    let queryBuilderFilterRuleDTO:QueryBuilderFilterRuleDTO = {"Filter": this.filter , "QueryBuilderFilterLineRule": filterData, "RuleAppliedList": ruleApplied }
    this._codingService.SaveFilter(queryBuilderFilterRuleDTO).subscribe((filterId:number) => 
    {
      this.filter.Id = filterId;
      this.filter.TabTitle = filterId;
      this._codingService.GetFilterLineWithChild(filterId).subscribe((data:any) => 
      {
        UtilRules.FormatRuleToString(data);
        this.query  = data;
        this.isSaveAsFilter = false;
        this.initRules();
        this.sucessMessage();
      });
    })
  }

  public onSaveProperties(ruleApplied){ 
    if(this.isSaveAsFilter){
      this.removeRuleAppledCharacterPlus(ruleApplied);
    }
    var tempData = Utils.DeepCopy(this.query);
    UtilRules.FormatRuleToArray(tempData,this.fieldsTypeMap);
    var filterData = <QueryBuilderFilterLineRuleDTO> tempData;
     UtilRules.FormatRuleAppliedPropertiesToArray(ruleApplied);
    let queryBuilderFilterRuleDTO:QueryBuilderFilterRuleDTO = {"Filter": this.filter , "QueryBuilderFilterLineRule": filterData, "RuleAppliedList": ruleApplied }
    this._codingService.SaveFilter(queryBuilderFilterRuleDTO).subscribe((filterId:number) => 
    {
      this.filter.Id = filterId;
      this.filter.TabTitle = filterId;
      this._codingService.GetFilterLineWithChild(filterId).subscribe((data:any) => 
      {
        UtilRules.FormatRuleToString(data);
        this.query  = data;
        this.isSaveAsFilter = false;
        this.initRules();
        this.sucessMessage();
      });
    })
  }
}
